/**
 * @author silence
 * @desc:个人中心接口
 * */
// 带fp的都要token
import request from '@/utils/ajax';

export function tCustMtaccount(data) {//入金账号信息
	return request({
		url: '/crm/reception/tCustMtaccount',
		method: 'get',
        params:data,
        addToken:true,
	});
}

export function mtAccList(data) {//出金账号信息
	return request({
		url: '/crm/reception/mtAccList',
		method: 'get',
        params:data,
        addToken:true,
	});
}

export function EnterMoeny(data) {//入金
	return request({
		url: '/crm/reception/deposit',
		method: 'POST',
        data,
        addToken:true,
	});
}

export function LeverWithdraw(data) {//出金
	return request({
		url: '/crm/reception/withdraw',
		method: 'POST',
        data,
        addToken:true,
	});
}
export function LeverWithdrawVer(data) {//出金验证码
	return request({
		url: '/crm/reception/withdraw/phoneVer',
		method: 'get',
        params: data,
        addToken:true,
	});
}

export function updateCustPass(data) {//官网客户修改登录密码
	return request({
		url: '/crm/auth/reception/updateCustPass',
		method: 'post',
		data,
        addToken:true,
	});
}
export function modifyMasterPwd(data) {//修改MT4账号交易密码
	return request({
		url: '/crm/reception/modifyMasterPwd',
		method: 'post',
		data,
        addToken:true,
	});
}

export function modifyInvPwd(data) {//修改MT4账号查询密码
	return request({
		url: '/crm/reception/modifyInvPwd',
		method: 'post',
		data,
        addToken:true,
	});
}

export function SettingVer(data) { //设置修改密码获取验证码
	return request({
		url: '/crm/reception/accSetting/modifyPwd/sendVer',
		method: 'GET',
		params: data,
        addToken:true,
	});
}

/**
 *
 * @param data custId
 * @returns {*}
 * @constructor
 */
export function GetCustInFo(data) { //供官网查询客户信息
	return request({
		url: '/crm/reception/personal/custInfo',
		method: 'GET',
		params: data,
        addToken:true,
	});
}

/**
 * 获取旧手机验证码
 * @returns {*}
 */
export function getOldPhoneVerCode(){
  return request({
    url: '/crm/reception/addPhone/sendVerToOldPhone',
    method: 'GET',
    addToken:true,
  });
}

/**
 * 请求参数：verCode - 验证码
 相应字段：preOperationId - 前置操作id
 * @param data
 * @returns {*}
 */
export function checkOldPhone(data){
  return request({
    url: '/crm/reception/addPhone/checkOldPhone',
    method: 'GET',
    params: data,
    addToken:true,
  });
}


export function getAddPhoneVer(data) { //添加手机号验证码
	return request({
		url: '/crm/reception/addPhone/sendVer',
		method: 'GET',
		params: data,
        addToken:true,
	});
}
export function addPhoneSubmit(data) { //添加手机号验证码
	return request({
		url: '/crm/reception/addPhone/commit',
		method: 'post',
		data,
        addToken:true,
	});
}
export function GetPartnerOrder(baseUrl,data) {
	return request({
		url: baseUrl,
		method: 'post',
		data,
        addToken:true,
	});
}

export function GetCommiPhoneVer(data) {
	return request({
		url: '/crm/reception/tMerchantCommission/commissionApplyPhoneVer',
		method: 'GET',
		params: data,
        addToken:true,
	});
}

export function CommiApply(data) {
	return request({
		url: '/crm/reception/tMerchantCommission',
		method: 'post',
		data,
        addToken:true,
	});
}

export function getMt4Group(data) {
	return request({
		url: '/crm/reception/tMt4Group',
		method: 'GET',
		params: data,
        addToken:true,
	});
}


export function getGroupByName(data) {
	return request({
		url: '/crm/reception/getGroupByName',
		method: 'GET',
		params: data,
        addToken:true,
	});
}

export function modifyLev(data) {
	return request({
		url: '/crm/reception/modifyLev',
		method: 'POST',
		data,
        addToken:true,
	});
}

export function openMT4Acc(data) {
	return request({
		url: '/crm/reception/openMT4Acc',
		method: 'GET',
		params: data,
        addToken:true,
	});
}

export function getPartnerData(data) {
	return request({
		url: '/crm/reception/personal/partner',
		method: 'GET',
		params: data,
        addToken:true,
	});
}

export function getPartnerCenterData(data) {
	return request({
		url: '/crm/reception/partner/link',
		method: 'GET',
		params: data,
        addToken:true,
	});
}

export function getTransferPhoneVer(data) {
	return request({
		url: '/crm/reception/personal/transferPhoneVer',
		method: 'GET',
		params: data,
        addToken:true,
	});
}


export function mt4Transfer(data) {
	return request({
		url: '/crm/reception/personal/mt4Transfer',
		method: 'POST',
		data,
        addToken:true,
	});
}

export function getNoticeOpt(data) {
	return request({
		url: '/crm/reception/queryNoticeConfig',
		method: 'GET',
		params: data,
        addToken:true,
	});
}

export function setNoticeOpt(data) {
	return request({
		url: '/crm/reception/updateNoticeConfig',
		method: 'put',
		data: data,
        addToken:true,
	});
}

export function getUSDExRateAndFee(data) {
	return request({
		url: '/crm/reception/depWith/getUSDExRateAndFee',
		method: 'GET',
		params: data,
        addToken:true,
	});
}


/*新银联卡支付方式 的订单信息*/
/*
* id 流水   payerName 支付者姓名
* */
export function payConfirm(data) {
  return request({
    url: '/crm/reception/confirm',
    method: 'POST',
    data: data,
    addToken:true,
  });
}

// 赠金相关的

export function queryRecordGiveGold(data) {
	return request({
		url: '/crm/reception/queryRecordByUserId',
		method: 'get',
		data: data,

	});
}

export function transferCredits(data) {
	return request({
		url: '/crm/reception/updateGoldYield',
		method: 'get',
		params: data,
		addToken:true,
	});
}
//  前台取消信用额 status 传7
export function cancleCredits(data) {
	return request({
		url: '/crm/reception/updateTCustBonusActStatus',
		method: 'put',
		data: data,
		addToken:true,
	});
}
// 代理
// 1、queryTMerchantCommissionLevels 前台查询代理级别
// 2、queryTMerchantCommissionLevelsRule 前台查询代理级别规则
// 3、queryTMerchantCommissionLevelsRule_Put 前台编辑返佣规则
/**
 *
 * @param data: custId
 * GET
 */
export function queryTMerchantCommissionLevels(data) {
  return request({
    url: '/crm/reception/queryTMerchantCommissionLevels',
    method: 'get',
    params: data,
    addToken:true,
  });
}

/**
 *
 * @param data id 代理级别id
 */
export function queryTMerchantCommissionLevelsRule(data) {
  return request({
    url: '/crm/reception/queryTMerchantCommissionLevelsRule',
    method: 'get',
    params: data,
    addToken:true,
  });
}

/**
 * 编辑代理规则levelId
 * dataList
 */
export function editTMerchantCommissionLevelsRule(data) {
  return request({
    url: '/crm/reception/queryTMerchantCommissionLevelsRule',
    method: 'put',
    data: data,
    addToken:true,
  });
}
// 前台新增代理级别
// name：代理级别名称，
// custId：代理id，
// newRules：返佣规则列表
export function addTMerchantCommissionLevelsRule(data) {
  return request({
    url: '/crm/reception/commissionLevel',
    method: 'post',
    data: data,
    addToken:true,
  });
}

// 前台查询子代理列表
export function querySubAgents(data) {
  return request({
    url: '/crm/reception/childIbList',
    method: 'get',
    params: data,
    addToken:true,
  });
}
//custId：子ib的id，
// levelId：代理级别id
export function editLevel(data) {
  return request({
    url: '/crm/reception/commissionLevel',
    method: 'put',
    params: data,
    addToken:true,
  });
}

export function getSymbolList(data) {
  return request({
    url: '/crm/fp/tMt4TradeSymbol',
    method: 'get',
    addToken:true,
  });
}
/*
1、个人中心-主页-合伙人-获取合伙人账户信息
URL：/crm/reception/getPartnerInfo
请求方式：get
参数：custId 客户id
返回：
		remainAmount：可出佣金额
totalAmount：佣金总额
custNumber：客户数
ibCustNumber:ib数
loginNumber：客户账户数
equity：净值
balance：余额
nowVolume：当前手数
totalVolume：累积手数*/
export function getPartnerInfo(data) {
  return request({
    url: '/crm/reception/getPartnerInfo',
    method: 'get',
    addToken:true,
    params:data,
  });
}

/**
 * 个人中心-主页-合伙人-佣金统计以及贡献排名
 URL：/crm/reception/commissionStatistics
 请求方式：get
 参数：custId 客户id
 timeType 时间类型 1-天 2-月
 timeNumber 时间数量
 返回：
 times：时间线坐标
 amount：佣金线坐标
 statisticsAmount：佣金合计
 custInfo：{
			custId:前八名客户id
			custName：客户姓名
			amount：佣金
		}
 备注：今日佣金从时间线坐标和佣金线坐标中获取今天的佣金即可（第一个数据或最后一个数据）
 * @param data
 */
export function getCommissionStatistics(data) {
  return request({
    url: '/crm/reception/commissionStatistics',
    method: 'get',
    addToken:true,
    params:data,
  });
}

/*
*
* 个人中心-主页-合伙人-开户统计
	URL：/crm/reception/registerStatistics
	请求方式：get
	参数：custId 客户id
		timeType 时间类型 1-天 2-月
		timeNumber 时间数量
	返回：
		statisticsNumber：开户总数
		times：时间线坐标
		loginNumber：开户数坐标
	备注：今日开户数从时间线坐标和开户数坐标中获取今天的开户数即可（第一个数据或最后一个数据）
* */
export function getRegisterStatistics(data) {
  return request({
    url: '/crm/reception/registerStatistics',
    method: 'get',
    addToken:true,
    params:data,
  });
}

/*
*
* 个人中心-出金和转账-获取银行卡信息
	URL：/crm/reception/getBankInfo
	请求方式：get
	参数：custId 客户id
	返回：
		firstName：姓
		lastName：名
		bankName：开户银行
		bankAccount：银行账号
		swiftCode：swiftCode
		bankStatus：审核状态 1:待审核 2:审核不通过 3:审核通过
* */
export function getBankInfo(data) {
  return request({
    url: '/crm/reception/getBankInfo',
    method: 'get',
    addToken:true,
    params:data,
  });
}

/**
 * 个人中心-客户管理-子IB列表-返佣规则 custId:必须
 * @param data
 */
export function getAllSubRules(data) {
  return request({
    url: '/crm/reception/childLevleAndRules',
    method: 'get',
    addToken:true,
    params:data,
  });
}

/**
 * 新增接口：资料认证保存接口
 * @param data
 */

export function savePerfectInfoStep(data) {
  return request({
    url: '/crm/reception/tCustInfo/preservation',
    method: 'post',
    addToken:true,
    data,
  });
}

/**
 * 开立模拟账户接口：
 get请求
 参数：custId 客户id
 * @param data
 */
export function openMockMt4(data) {
  return request({
    url: 'crm/auth/reception/createSimulationLogin',
    method: 'GET',
    params: data,
    addToken:true,
  });
}


export function checkNick(data) {
  return request({
    url: 'crm/fp/checkAlias',
    method: 'GET',
    params: data,
  });
}


// 公告详情
export function querycommunitynoticedetail(data) {
  return request({
    url: '/crm/reception/queryNoticeById',
    method: 'get',
    params: data,
    addToken:true,
  });
}



//  查询剩余开户数 最多20
export function queryAccountLimit(data) {
  return request({
    url: '/crm/reception/necessaryInfo',
    method: 'GET',
    params: data,
    addToken:true,
  });
}


export function queryTopSignal(data) {
  return request({
    url: '/crm/reception/queryRanking',
    method: 'GET',
    params: data,
    addToken:true,
  });
}
//
export function queryTradePriceInformation(data) {
  return request({
    url: '/crm/reception/subscriptionInfo',
    method: 'GET',
    params: data,
  });
}

/*
查看直客邀请链接列表
 */
export function getDirectGuestInvitationLinks(){
  return request({
    url: '/crm/reception/custLink',
    method: 'GET',
    addToken:true,
  });
}

/*
获取候选自定义开户分组配置 列表
 */
export function getUserDefinedGroupConfigList(){
  return request({
    url: '/crm/reception/customGroups',
    method: 'GET',
    addToken:true,
  });
}

/**
 * 添加自定义直客邀请链接
 */
export function addDirectGuestInvitationLinks(data){
  return request({
    url: '/crm/reception/custLink',
    method: 'POST',
    data,
    addToken:true,
  });
}

/**
 * 编辑自定义直客邀请链接
 * id	链接id	Y	整型
 levelName	链接名称	Y	字符串
 custGroups	参数数组	Y	数组
 id	开户配置id	Y	整型
 groupId	大账户分组ID	Y	整型
 groupDetailId	小账户分组ID	Y	整型
 */

export function editDirectGuestInvitationLinks(data){
  return request({
    url: '/crm/reception/custLink',
    method: 'PUT',
    data,
    addToken:true,
  });
}

/**
 *
 * @param data
 * @returns {*}
 */
export function getDynamicInfo(data){
  return request({
    url: '/crm/reception/tDynamicInfo',
    method: 'get',
    params: data,
    addToken:true,
  });
}

/**
 *积分商城列表
 * @param data
 * @returns {*}
 */
export function queryProcutList(data){
  return request({
    url: '/crm/reception/tShopProduct',
    method: 'get',
    params: data,
    addToken:true,
  });
}
// 查询商品详情
export function queryProcutDetail(data){
  return request({
    url: '/crm/reception/tShopProduct/detail',
    method: 'get',
    params: data,
    addToken:true,
  });
}

// 查询购物车详情
export function queryShopCarDetail(data){
  return request({
    url: '/crm/reception/tShopCart',
    method: 'get',
    params: data,
    addToken:true,
  });
}

// 添加商品到购物车
export function addProductToCar(data){
  return request({
    url: '/crm/reception/tShopCart',
    method: 'post',
    data,
    addToken:true,
  });
}

// 编辑购物车商品数量
export function editCarProductNum(data){
  return request({
    url: '/crm/reception/tShopCart',
    method: 'put',
    data,
    addToken:true,
  });
}

// 清空购物车
export function clearShopCar(data){
  return request({
    url: '/crm/reception/clearAllCart',
    method: 'put',
    params: data,
    addToken:true,
  });
}


// 提交兑换申请
export function applyExchange(data){
  return request({
    url: '/crm/reception/rewardRedeemRecord',
    method: 'post',
    data,
    addToken:true,
  });
}

//
export function addOrEditShippingAddress
(data){
  return request({
    url: '/crm/reception/tShopShippingInfo',
    method: 'post',
    data,
    addToken:true,
  });
}


// 查询渠道

export function queryTPayType
(data){
  return request({
    url: '/crm/fp/tPayType',
    method: 'get',
    params: data,
    addToken:true,
  });
}

export function queryFaqList(data){
  return request({
    url: '/crm/reception/tCustFaq',
    method: 'get',
    params: data,
    addToken:true,
  });
}








